import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import DashBoardLayout from '../Layouts/dashBoardLayout'
import DashboardRoutes from './DashboardRoutes'
import LoginRoutes from './LoginRoutes'
import { useLocation, useNavigate } from 'react-router-dom'

const Routing = () => {
    const authToken = useSelector(state => state.login.data.token)
    const location = useLocation();
    const navigate = useNavigate();
  
    useEffect(() => {
      const isChatPath = location.pathname.startsWith("/app/ChatDetails/") || location.pathname.startsWith("/chef/ChatDetails/");
      if (isChatPath && authToken) {
        const parts = location.pathname.split("/");
        const roomId = parts[parts.length - 1] || location.state?.roomId;
  
        if (roomId) {
          navigate("/dashboard/mychats", { state: { roomId } });
        }
      }
    }, []);

    return (
        <>
            {authToken !== "" && authToken !== null && authToken !== undefined ? <DashboardRoutes /> : <LoginRoutes />}



        </>
    )
}

export default Routing